import React from 'react';
import HeaderButton from './ui/HeaderButton';
import { translate } from '../../Services/translation';

const ProSearch = () => {
  const onClick = () => {
    console.log('Not yet implemented'); // TODO: Add ProsearchToggle logic
  };

  return (
    <HeaderButton
      icon="Search-Menu"
      label={translate('general.prosearch')}
      onClick={onClick}
      hideOnMobile={true}
      disabled={true}
    />
  );
};

export default ProSearch;
